import { createContext } from "react"

const AccessContext = createContext();

export default AccessContext;